import { render, staticRenderFns } from "./PHeader.vue?vue&type=template&id=404a3dd8&scoped=true&"
import script from "./PHeader.vue?vue&type=script&lang=ts&"
export * from "./PHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PHeader.vue?vue&type=style&index=0&id=404a3dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a3dd8",
  null
  
)

export default component.exports